export default "__VITE_PUBLIC_ASSET__39a2e397__"